import { AvailableLibraryList } from './AvailableLibraryList';

export const CodeGuide = () => {
  return (
    <div className="px-2">
      <h3 className="mb-2 font-medium">Using Variables</h3>
      <div className="mb-3 text-sm text-gray-700 dark:text-gray-300">
        Use <code className="rounded bg-gray-100 px-1 py-0.5 dark:bg-gray-800">VARS</code> to access variables defined
        in your test or on the project.
      </div>
      <h3 className="mb-2 font-medium">Available Libraries</h3>
      <AvailableLibraryList />
    </div>
  );
};
